var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.project.configuration !== null)?_c('div',{staticClass:"row mb-3 align-items-center"},[_c('div',{staticClass:"col-12 col-md-9"},[_c('h5',[_vm._v(_vm._s(_vm.project.configuration.description))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }